import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, } from '@angular/core';
import { Observable, Subscription, } from 'rxjs';
import { AddressModel } from 'src/app/core/models/address.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { ClientListService } from '../../../core/services/list-services/client-list.service';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ClientBaseModel } from 'src/app/core/models/members/client/client-base-model';
import { ClientSignatureModel } from 'src/app/core/models/members/client/client-signature.model';
import { InsuranceCompany } from 'src/app/core/models/members/client/insurance-company.model';
import { ErrorModel } from 'src/app/core/models/error.model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { InviteModalService } from 'src/app/core/services/modal-services/invite-modal.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { GlobalComponent } from 'src/app/global-component';
import Swal from 'sweetalert2';
import { ClientListSortBy } from 'src/app/core/enums/sort-by-options/client-list-sort-enum';
import { TaskModel } from 'src/app/core/models/task/task.model';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ClientListTableConfig } from './configs/client-list.config';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { ExportType } from 'src/app/core/models/reporting/export-config-model';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ClientListFilter } from './configs/client-list-filter-config-enum';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { TableConfigService } from 'src/app/core/services/table-config.service';
import { BoolEnum } from 'src/app/core/enums/bool-enum';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss'],
  providers: [ClientListService, DecimalPipe],
})

export class ClientListComponent extends ListLayoutExtendableComponent {

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  clientIsEnabledSelectedOption: boolean | undefined;

  override listItemsObservable!: Observable<ClientBaseModel[]>;


  sortBy: ClientListSortBy = ClientListSortBy.None;

  viewModel: boolean = false;

  model: ClientSignatureModel = new ClientModel();
  clientSignature: ClientSignatureModel = new ClientSignatureModel;

  //Security Operations of the current User
  securityPermissionClientCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientCreate);
  securityPermissionClientDelete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientDelete);
  securityPermissionClientManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientManagement);
  securityPermissionClientUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientUpdate);

  enumFileManagementSortBy = ClientListSortBy;

  configItemsObservable!: Observable<TableConfigurationModel[]>;

  protected override searchPlaceHolderText: string = "Search for client number, name, or email";

  //this is here incase a client is passed to the base management page list from else where 
  @Input() public referenceModel: ClientModel = new ClientModel();
  @Input() public disabled: boolean = false;
  @Output() referenceModelChange = new EventEmitter<any>();
  @Output() listUpdated = new EventEmitter<boolean>();

  constructor(
    protected taskModalService: TaskModalService,
    protected clientListService: ClientListService,
    protected myInviteModalService: InviteModalService,
    protected tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override openModalService: OpenModalService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnInit(): void {

    this.tableConfig = new ClientListTableConfig();

    this.configItemsObservable = this.tableConfigService.resultItems$;
    const subscrConfig = this.configItemsObservable.subscribe(result => {
      if (result && result[0]) {
        //needed to be able to avoid null from the model when its decoded. 
        this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
          if (value !== null) return value;
        }));
        if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
          this.clientListService.pageSize = this.tableConfig.pageSize;
        }
      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = this.authMyFileService.currentUserContextValue?.id;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.clientListService.resultItems$;
    this.total = this.clientListService.total$;
    this.isLoading = this.clientListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((clientModel: ClientBaseModel) => {
        this.getEntityPhoto(clientModel, EntityTypeEnum.Client);
      });
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.clientListService.totalRecords;
      this.serviceData.pageSize = this.clientListService.pageSize;
      this.serviceData.pageIndex = this.clientListService.pageIndex;
    });
  }

  ngOnDestroy() {
    this.clearSearch(this.clientListService);
    this.clearSearch(this.tableConfigService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  clientStatusFilter(status: any) {
    this.clientListService.status = status.value;
  }

  openModalEdit(clientId: string, $event: MouseEvent, activeTab?: number) {
    if (clientId == undefined) {
      this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    } else {
      this.model.id = clientId;
      this.openModalService.editClientModal(this.clientListService, clientId, undefined, undefined, $event, activeTab)
    }
    $event.stopPropagation();
  }

  sideProfileView(modelId: string) {
    this.viewModel = true;
    this.isLoadingVal = true;
    var sub: Subscription = this.myFileApiService.getClient(modelId)
      .subscribe((client: ClientSignatureModel | undefined) => {
        if (client) {
          this.model = client;
          this.legacyModelCheckAndSet()
          this.clientSignature = this.model;
        }
        this.isLoadingVal = false;
        sub.unsubscribe();
      });
  }

  loadClient(clientPreload: ClientBaseModel) {
    this.submitted = true;
    this.myFileApiService.getClient(clientPreload.id!)
      .subscribe((client: ClientSignatureModel | undefined) => {
        if (client) {
          this.model = client;
          this.legacyModelCheckAndSet()
          this.model.listPhoto = clientPreload.listPhoto;
        }
        this.submitted = false;
      });
  }

  legacyModelCheckAndSet() {
    this.getEntityPhoto(this.model, EntityTypeEnum.Client);

    if (this.model.address == null || this.model.address == undefined) {
      this.model.address = new AddressModel();  //used for legacy clients
    }

    if (this.model.opposingCounsel.address == null || this.model.opposingCounsel.address == undefined) {
      this.model.opposingCounsel.address = new AddressModel();
    }

    if (this.model.insuranceCompany == null || this.model.insuranceCompany == undefined) {
      this.model.insuranceCompany = new InsuranceCompany();
    }
  }

  deleteData(clientModelId: string) {
    this.submitted = true;
    Swal.fire({
      title: $localize`:@@:Delete Client`,
      text: $localize`:@@:Are you sure you want to delete this Client?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Ok`,
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        this.myFileApiService.deleteClient(clientModelId).subscribe((result: ErrorModel | boolean | undefined) => {
          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@: Client has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
          this.serviceSort(this.clientListService, '', '');
          this.submitted = false;
        });
      } else {
        this.submitted = false;
      }
    });
  }

  signaturePNGTransform() {
    if (this.clientSignature.signature) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.clientSignature.signature}`);
    }
    return GlobalComponent.defaultNoSignatureImage;
  }

  trackByFn(item: any) {
    return item.id;
  }

  exportClients() {
    this.myFileApiService.newTaskClientExport().subscribe((newTaskModel: TaskModel | undefined) => {
      if (newTaskModel !== undefined) {
        this.taskModalService.openModal(newTaskModel, this.checkedValGet), "Export";
      }
    });
  }

  //** new simpler sort function for further lists with new layout component */
  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.clientListService, '', '');
    } else {
      this.serviceSort(this.clientListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  buttonActionSelected(buttonAction: any) {
    var action = buttonAction;

    if (buttonAction.buttonId !== undefined) {
      action = buttonAction.buttonId;
    }
    switch (action) {

      case ButtonIdEnum.CreateNew:
        this.openModalNew()
        break;
      case ButtonIdEnum.Invite:
        this.openInviteModal()
        break;
      case ButtonIdEnum.Delete:
        this.deleteMultipleClients();
        break;
      case `${ButtonIdEnum.ExportCSV}`:
        this.exportTo(ExportType.Csv, this.clientListService.searchModel, 'Clients', 'Clients',this.tableConfig)
        break;
      case `${ButtonIdEnum.ExportExcel}`:
        this.exportTo(ExportType.Excel, this.clientListService.searchModel, 'Clients', 'Clients',this.tableConfig)
        break;
      case `${ButtonIdEnum.ExportTenant}`:
        if (this.checkedValGet == undefined || this.checkedValGet.length == 0) {
          Swal.fire({
            icon: 'warning',
            text: 'Please select the record(s) to Export',
            color: 'var(--vz-body-color)',
            background: 'var(--vz-body-bg)',
            confirmButtonColor: '#299cdb',
          });
        } else {
          this.myFileApiService.newTaskClientExport().subscribe((newTaskModel: TaskModel | undefined) => {
            if (newTaskModel !== undefined) {
              this.taskModalService.openModal(newTaskModel, this.checkedValGet, "Export");
            }
          });
        }
        break;
    }
  }

  openInviteModal() {
    this.myInviteModalService.openModal(LoginType.Client);
  }

  deleteMultipleClients() {
    var checkboxes: any = document.getElementsByName('checkAll');
    var result
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }
    if (checkedVal.length > 1) {
      Swal.fire({
        title: $localize`:@@:Delete Multiple Clients`,
        text: $localize`:@@:Are you sure you want to delete these clients?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          for (var i = 0; i < checkedVal.length; i++) {
            var reloadList: number = checkedVal.length;

            this.myFileApiService.deleteClient(checkedVal[i]).subscribe((result: ErrorModel | boolean | undefined) => {
              reloadList = reloadList - 1;
              if (reloadList == 0) {
                this.serviceSort(this.clientListService, '', '');
              }
              if (result) {
                this.toasterNotificationService.showSuccess($localize`:@@: Client has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
              }
            });
          }
        }
      });
    } else if (checkedVal.length == 1) {
      this.deleteData(checkedVal[0]);
    }
    else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select a Client',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }
    this.checkedValGet = checkedVal;
  }


  openModalNew() {
    this.openModalService.newClientModal(this.clientListService);
    var sub: Subscription = this.openModalService.serviceSortUpdated.subscribe((result: any) => {
      if (result) {
        this.listUpdated.emit(true);
      }
      sub.unsubscribe();
    });
  }


  rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.serviceData.loadingValue = true;
        this.openModalService.editClientModal(this.clientListService, rowAction.model.id, undefined, undefined);
        var sub: Subscription = this.openModalService.serviceSortUpdated.subscribe((result: any) => {
          if (result) {
            this.listUpdated.emit(true);
          }
          sub.unsubscribe();
        });
        break;
      case ActionIdEnum.Delete:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.serviceData.loadingValue = true;
          this.deleteData(rowAction.model.id)
        }
        break;
      case ActionIdEnum.Notes:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.serviceData.loadingValue = true;
        this.openModalService.editClientModal(this.clientListService, rowAction.model.id, undefined, undefined, undefined, 5);
        var sub: Subscription = this.openModalService.serviceSortUpdated.subscribe((result: any) => {
          if (result) {
            this.listUpdated.emit(true);
          }
          sub.unsubscribe();
        });
        break;
      case ActionIdEnum.View:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.sideProfileView(rowAction.model.id)
        }
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel) {
    switch (filterSelected.label) {
      case ClientListFilter.ClientStatusFilter:
        this.clientListService.status = filterSelected.selectedOption;
        break;
      case ClientListFilter.ClientEnabledFilter:
        if (filterSelected.selectedOption === BoolEnum.True) {
          this.clientListService.isEnabled = true;
        } else if (filterSelected.selectedOption === BoolEnum.False) {
          this.clientListService.isEnabled = false;
        } else {
          this.clientListService.isEnabled = filterSelected.selectedOption;
        }
        break;
    }
  }

}
